var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 17 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.467 0.754997L15.602 8.094C16.889 8.872 16.889 10.739 15.602 11.517L3.467 18.856C2.134 19.662 0.431999 18.702 0.431999 17.145V2.466C0.431999 0.908996 2.134 -0.051003 3.467 0.754997Z",
    fill: "#499ED7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.467 18.855L15.602 11.516C16.889 10.738 16.889 8.871 15.602 8.093L13.145 6.607L13.025 6.603L2.642 19.118C2.93324 19.0933 3.21519 19.0034 3.467 18.855Z",
    fill: "#F04C4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.431999 14.415V17.144C0.431999 18.702 2.134 19.661 3.467 18.855L15.602 11.516C16.367 11.054 16.666 10.208 16.521 9.434L0.431999 14.415Z",
    fill: "#2B8EC6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.51 0.699997C1.18451 0.865798 0.911411 1.11866 0.721091 1.43045C0.53077 1.74223 0.430695 2.10071 0.432 2.466V5.032L1.51 0.699997Z",
    fill: "#499ED7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.602 8.094L3.467 0.754997C3.21453 0.606287 2.93193 0.516075 2.64 0.490997L13.024 13.076L15.603 11.517C16.889 10.738 16.889 8.872 15.602 8.094Z",
    fill: "#92CA62"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.657 11.869L2.642 19.119C2.921 19.09 3.201 19.016 3.467 18.856L15.602 11.517C16.367 11.055 16.666 10.209 16.521 9.435L8.657 11.869Z",
    fill: "#E13340"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.602 8.094L13.145 6.608L13.025 6.604L10.347 9.832L13.024 13.076L15.603 11.517C16.889 10.738 16.889 8.872 15.602 8.094Z",
    fill: "#FCD770"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.342 11.037L13.024 13.075L15.603 11.516C16.368 11.054 16.667 10.208 16.522 9.434L11.342 11.037Z",
    fill: "#FFCC5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/play-store.e46940ad53d77f647f2393543d6be7d6.svg";
export { ForwardRef as ReactComponent };